import type { RouterContextType } from "@/api/permissions/permissions.api";
import { authGuardWithPermissions } from "@/utils/authGuard";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/service-providers/$id/alignment/_alignmentLayout/$providerType/$stepId/",
)({
  beforeLoad: async (args) => {
    await authGuardWithPermissions({
      context: args.context as RouterContextType,
      location: args.location as { pathname: string },
    });

    // Alignment is a single page now; old per-step deep links land on it.
    throw redirect({
      to: "/service-providers/$id/alignment/$providerType",
      params: { id: args.params.id, providerType: args.params.providerType },
      replace: true,
    });
  },
  component: () => null,
});

// Step-scoped form data is still fetched by the SP detail tabs, which reuse
// these identifiers (see useAlignmentQueries / useAlignmentMutations).
export const ALIGNMENT_ALLOWED_STEPS = [
  "application-info",
  "business-information",
  "owner-information",
] as const;

export const STEP_ID_MAP: Record<string, string> = {
  "owner-information": "application-info",
};
